// extracted by mini-css-extract-plugin
export var jumbotron = "Jumbotron-module--jumbotron--WEXhX";
export var container = "Jumbotron-module--container--QsyYz";
export var row = "Jumbotron-module--row--sshVV";
export var logoWrapper = "Jumbotron-module--logo-wrapper--rqpfo";
export var logo = "Jumbotron-module--logo--3aQhG";
export var textWrapper = "Jumbotron-module--text-wrapper--GEkdQ";
export var headline = "Jumbotron-module--headline--3iPW1";
export var intro = "Jumbotron-module--intro--2vcL+";